import React from 'react';

// HoC
import { withStyles } from '@material-ui/core/styles';
// Component
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

const styles = theme => ({
  root: {},
  error: {
    color: '#f44336',
  },
});

const DropdownInput = props => {
  const {
    fieldId,
    fieldName,
    value,
    error,
    fieldOptions = [],
    onChange,
    classes,
  } = props || {};
  return (
    <FormControl fullWidth classes={{ root: classes.root }} error={error}>
      <InputLabel
        shrink={value !== null && value !== undefined}
        htmlFor={fieldId}
      >
        {fieldName}
      </InputLabel>
      <Select
        value={value || ''}
        onChange={({ target: { value } = {} } = {}) => onChange(value)}
        inputProps={{
          name: fieldName,
          id: fieldId,
        }}
        data-test-id={`DropdownInput-${fieldName}`}
      >
        {fieldOptions.map(option => (
          <MenuItem
            key={option}
            value={option}
            data-test-id={`DropdownInput-menuItem-${option}`}
          >
            {option}
          </MenuItem>
        ))}
      </Select>
      {error && (
        <FormHelperText className={classes.error}>{error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default withStyles(styles)(DropdownInput);
